
import '~/js/views/general/includes/scroll-below';

import 'slick-carousel';

const $sliderExchange1 = $('.js-slick-slider-exchange-1');
const $sliderExchange2 = $('.js-slick-slider-exchange-2');
const $sliderExchange3 = $('.js-slick-slider-exchange-3');

$sliderExchange1.slick({
    centerPadding: '0',
    cssEase: 'ease-out',
    lazyLoad: 'progressive',
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    speed: 500,
    dots: true,
    prevArrow: $('.js-prev-slide-in-slider-exchange-1'),
    nextArrow: $('.js-next-slide-in-slider-exchange-1'),
    responsive: [{
        breakpoint: 768,
        settings: {
            lazyLoad: 'ondemand',
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }]
});

$sliderExchange2.slick({
    centerPadding: '0',
    cssEase: 'ease-out',
    lazyLoad: 'progressive',
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    speed: 500,
    dots: false,
    prevArrow: $('.js-prev-slide-in-slider-exchange-2'),
    nextArrow: $('.js-next-slide-in-slider-exchange-2'),
    responsive: [{
        breakpoint: 768,
        settings: {
            lazyLoad: 'ondemand',
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true
        }
    }]
});

$sliderExchange3.slick({
    centerPadding: '0',
    cssEase: 'ease-out',
    lazyLoad: 'progressive',
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    speed: 500,
    dots: false,
    prevArrow: $('.js-prev-slide-in-slider-exchange-3'),
    nextArrow: $('.js-next-slide-in-slider-exchange-3'),
    responsive: [{
        breakpoint: 768,
        settings: {
            lazyLoad: 'ondemand',
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }]
});
